export default {
  tiandituKey: 'd77e581bdcd973737d60ac502fa02360' // 天地图 key
}
